import React, { } from "react";
import { FaUserTie,FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import useIntersectionObserver from "./home-animation";
export default function HomeWhatWe() {
    const [sectionRef1, isVisible1] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef2, isVisible2] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef3, isVisible3] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef4, isVisible4] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef5, isVisible5] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef6, isVisible6] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef7, isVisible7] = useIntersectionObserver({ threshold: 0.1 });
    return (
        <div className="home-whatwe">
            <div className="outer-container">
                <div className="home-whatwe-row">
                <div className="home-whatwe-left">
                    <div className="home-whatwe-head">What We Provide</div>
                    <div className={`home-whatwe-mainhead ${isVisible1? 'animate__fadeInLeft' : ''}`}  style={{ animationDuration: '1.25s' }} ref={sectionRef1}>Empowering Recruiters with Comprehensive Solutions</div>
                </div>
                <div className={`home-whatwe-right ${isVisible2? 'animate__fadeInUp' : ''}`}  style={{ animationDuration: '1.25s' }} ref={sectionRef2}>
                    <p className="main-para">Elevate your recruitment process with our advanced tools and expertise. From talent acquisition to HR solutions, we streamline every step to ensure your success.</p>
                </div>
                <div className="home-what-box-outer">
               <div className="home-what-box-inner animate__fadeInUp"  style={{ animationDuration: '1.25s' }}>
                    <div className="home-what-gray-box">
                        <div className="home-what-icon-box">
                            <FaUserTie className="home-what-icon"/>
                        </div>
                        <div className="home-info-box-title"> Recruitment</div>
                        <p className="main-para animate__fadeInUp" style={{ animationDuration: '1.25s' }}> Efficiently source, screen, and hire top talent with our innovative recruitment solutions tailored to your needs.</p>
                        {/* <span to="/" className="home-info-link">Learn more <FaArrowRight className="ms-1"/></span> */}
                    </div>
                </div>
                <div className={`home-what-box-inner ${isVisible3 ? 'animate__fadeInUp' : ''}`}  style={{ animationDuration: '1.25s' }}  ref={sectionRef3}>
                    <div className="home-what-gray-box">
                        <div className="home-what-icon-box">
                            <FaUserTie className="home-what-icon"/>
                        </div>
                        <div className="home-info-box-title"> Career Growth</div>
                        <p className="main-para">Support employee development and retention with personalized career growth strategies and resources.</p>
                        {/* <span to="/" className="home-info-link">Learn more <FaArrowRight className="ms-1"/></span> */}
                    </div>
                </div>
               <div className={`home-what-box-inner ${isVisible4 ? 'animate__fadeInUp' : ''}`}  style={{ animationDuration: '1.25s' }}  ref={sectionRef4}>
                    <div className="home-what-gray-box">
                        <div className="home-what-icon-box">
                            <FaUserTie className="home-what-icon"/>
                        </div>
                        <div className="home-info-box-title"> Gig Economy</div>
                        <p className="main-para">Harness the power of freelance and contract talent seamlessly integrated into your workforce strategy.</p>
                        {/* <span to="/" className="home-info-link">Learn more<FaArrowRight className="ms-1"/> </span> */}
                    </div>
                </div>
               <div className={`home-what-box-inner ${isVisible5 ? 'animate__fadeInUp' : ''}`}  style={{ animationDuration: '1.25s'}}  ref={sectionRef5}>
                    <div className="home-what-gray-box">
                        <div className="home-what-icon-box">
                            <FaUserTie className="home-what-icon"/>
                        </div>
                        <div className="home-info-box-title"> HR Solutions</div>
                        <p className="main-para">Simplify your HR operations with scalable solutions that optimize efficiency and compliance.</p>
                        {/* <span to="/" className="home-info-link">Learn more<FaArrowRight className="ms-1"/> </span> */}
                    </div>
                </div>
               <div className={`home-what-box-inner ${isVisible6 ? 'animate__fadeInUp' : ''}`}  style={{ animationDuration: '1.25s' }} ref={sectionRef6}>
                    <div className="home-what-gray-box">
                        <div className="home-what-icon-box">
                            <FaUserTie className="home-what-icon"/>
                        </div>
                        <div className="home-info-box-title"> Payroll Services</div>
                        <p className="main-para"> Streamline payroll management with accurate, compliant, and secure payroll services tailored to your business needs.</p>
                        {/* <span to="/" className="home-info-link">Learn more<FaArrowRight className="ms-1"/> </span> */}
                    </div>
                </div>
               <div className={`home-what-box-inner ${isVisible7 ? 'animate__fadeInUp' : ''}`}  style={{ animationDuration: '1.25s' }} ref={sectionRef7}>
                    <div className="home-what-gray-box">
                        <div className="home-what-icon-box">
                            <FaUserTie className="home-what-icon"/>
                        </div>
                        <div className="home-info-box-title"> Workforce System</div>
                        <p className="main-para">Optimize workforce management with our integrated solutions for scheduling, performance tracking, and employee engagement.</p>
                        {/* <span to="/" className="home-info-link">Learn more <FaArrowRight className="ms-1"/></span> */}
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    );
}
